import React, { useState, useEffect } from 'react';
import './HeroSection.css';
import bg1 from '../assets/bg1.JPG';
import bg2 from '../assets/bg2.JPG';
import bg3 from '../assets/bg3.JPG';
import bg4 from '../assets/bg4.JPG';
import bg5 from '../assets/bg5.JPG';
import bg6 from '../assets/bg6.JPG';


const HeroSection = ({ language }) => {
  const t = {
    en: {
      welcome: "Welcome to Focus Saúde e Exercício.",
      subtitle: "We are Committed to your movement, strength, and rehabilitation",
    },
    pt: {
      welcome: "Bem-vindo à Focus Saúde e Exercício.",
      subtitle: "Estamos comprometidos com o seu movimento, força e reabilitação",
    }
  }[language];

  const images = [bg3, bg5, bg2, bg4, bg1, bg6];
  const [currentBg, setCurrentBg] = useState(0);
  const [prevBg, setPrevBg] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPrevBg(currentBg);
      setCurrentBg((prev) => (prev + 1) % images.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [currentBg, images.length]);

  return (
    <>
      <div className="hero-container">
        <div
          className="hero-bg"
          style={{ backgroundImage: `url(${images[prevBg]})`, opacity: 1 }}
        />
        <div
          className="hero-bg fade-in"
          style={{ backgroundImage: `url(${images[currentBg]})` }}
        />
        <div className="hero-overlay" />

        <div className="hero-content">
          <h1 className="animated-text">{t.welcome}</h1>
          <p>{t.subtitle}</p>
        </div>
      </div>

    </>
  );
};

export default HeroSection;
